<template>
  <div class="content">
    <div class="control_bar">
      <div class="column_export">
        <span
          class="column_export assessmentInfos_export"
          @click="exportAction"
        >
          {{ exportButton }}
        </span>
      </div>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="total_period">
          <div class="total_period_label assessment_title_label">
            {{ totalPeriodLabel }}
          </div>
          <div class="start_date_time">
            {{ startDateTimeLabel }}
            <datepicker
              placeholder="Select Date"
              :config="config"
              :locale="ja"
              id="start"
              :value="value"
              @on-change="customFormatter"
              class="start_datepicker start_date_time"
            >
            </datepicker>
          </div>
          <div class="end_date_time">
            {{ endDateTimeLabel }}
            <datepicker
              placeholder="Select Date"
              :config="config"
              id="end"
              :value="value"
              @change="customFormatter"
              class="end_datepicker end_date_time"
            ></datepicker>
          </div>
        </div>
        <div class="count_units">
          <div class="count_units_label assessment_title_label">
            {{ countUnitsLabel }}
          </div>
          <div class="radio_buttons" id="count_units">
            <label>
              <input
                type="radio"
                id="day"
                name="count_units"
                checked
                value="0"
              />
              {{ dayLabel }}
            </label>
            <label>
              <input type="radio" id="week" name="count_units" value="1" />
              {{ weekLabel }}
            </label>
            <label>
              <input type="radio" id="month" name="count_units" value="2" />
              {{ monthLabel }}
            </label>
          </div>
        </div>
        <div class="aggregate_target">
          <div class="attention">
            {{ totalWarning }}
          </div>
          <div class="table_cell">
            <div class="aggregate_target_label assessment_title_label">
              {{ aggregateTargetLabel }}
            </div>
            <div class="all_label">
              <input type="checkbox" class="checkbox" id="all_checkbox" />
              <label for="all_checkbox">{{ allLabel }}</label>
            </div>
            <div class="posts_table">
              <label class="title assessment_title_label">
                {{ postsLabel }}
              </label>
              <div class="table">
                <table
                  class="table_header"
                  border="1"
                  cellpadding="2"
                  bordercolor="#fff"
                  style="border-collapse: collapse"
                >
                  <tr>
                    <th
                      class="table_first_child post_table_header_first_padding"
                    ></th>
                    <th class="post_table_content" align="left">
                      {{ postNameLabel }}
                    </th>
                  </tr>
                </table>

                <div class="edit_table_contents">
                  <table
                    class="edit_table_content"
                    border="1"
                    cellpadding="2"
                    bordercolor="#fff"
                    style="border-collapse: collapse"
                  >
                    <tr
                      class="table_row"
                      v-for="post in posts"
                      :key="post.postId"
                      @click="checkedPostsAction(post)"
                    >
                      <td class="table_first_child">
                        <input
                          type="checkbox"
                          class="checkbox"
                          :checked="post.checked"
                        />
                      </td>
                      <td class="post_table_content">
                        {{ post.postName }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="users_table">
              <label class="title assessment_title_label">
                {{ usersLabel }}
              </label>
              <div class="table">
                <table
                  class="table_header"
                  border="1"
                  cellpadding="2"
                  bordercolor="#fff"
                  style="border-collapse: collapse"
                >
                  <tr>
                    <th
                      class="table_first_child user_table_header_first_padding"
                    ></th>
                    <th align="left" class="user_secand_child">
                      {{ userIdLabel }}
                    </th>
                    <th align="left" class="user_third_child">
                      {{ userNameLabel }}
                    </th>
                  </tr>
                </table>

                <div class="edit_table_contents">
                  <table
                    class="edit_table_content"
                    border="1"
                    cellpadding="2"
                    bordercolor="#fff"
                    style="border-collapse: collapse"
                  >
                    <tr
                      class="table_row"
                      v-for="user in users"
                      :key="user.userId"
                      @click="checkedUsersAction(user)"
                    >
                      <td class="table_first_child">
                        <input
                          type="checkbox"
                          class="checkbox"
                          :checked="user.checked"
                        />
                      </td>
                      <td class="user_secand_child user_table_content">
                        {{ user.userId }}
                      </td>
                      <td class="user_third_child user_table_content">
                        {{ user.familyName }}{{ user.name }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="closeModal">
      </completeModalWindow>
    </div>
    <div class="export_modal_window" v-if="showExportModal">
      <exportModalWindow
        :exportList="checkedList"
        @close="closeModal"
        @export="exportList"
      >
      </exportModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import exportModalWindow from '../modalWindow/exportModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  data() {
    return {
      totalWarning: '*集計対象の選択は合わせて5件まで選択できます。',
      exportButton: 'エクスポート',
      totalPeriodLabel: '集計期間',
      startDateTimeLabel: '開始:',
      endDateTimeLabel: '終了:',
      countUnitsLabel: '集計単位',
      dayLabel: '日',
      weekLabel: '週',
      monthLabel: '月',
      aggregateTargetLabel: '集計対象',
      allLabel: '全体',
      postsLabel: 'メイン所属',
      postNameLabel: '所属名',
      usersLabel: 'ユーザ',
      userIdLabel: 'ユーザID',
      userNameLabel: 'ユーザ名',
      value: '',
      checkedUsersList: [],
      checkedPostsList: [],
      completeWord: '',
      allChecked: false,
      postsChecked: false,
      usersChecked: false,
      showCompleteModal: false,
      showExportModal: false,
      showloadingModal: false,
      ja: japanese,
      config: {
        dateformat: 'Y-m-d',
        locale: japanese,
        maxDate: '9999'
      }
    }
  },
  computed: {
    posts() {
      return this.$store.state.assessmentInfos.posts
    },
    users() {
      return this.$store.state.assessmentInfos.users
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
    completeModalWindow,
    exportModalWindow,
    loadingModalWindow,
    datepicker
  },
  async created() {
    this.showloadingModal = true
    try {
      await this.$store.dispatch('assessmentInfos/setUserInfos')
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_270002
      let eventType = 3
      let reason = 'MSGCRC0057 '
      if (error.response) {
        this.completeWord =
          this.errorMsg.MSGCRC0057.name +
          this.errorMsg.MSGCRC0057.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.completeWord =
          this.errorMsg.MSGCRC0005.name +
          this.errorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.showCompleteModal = true
      this.showloadingModal = false
      return
    }
    try {
      await this.$store.dispatch('assessmentInfos/setPostInfos')
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_270003
      let eventType = 3
      let reason = 'MSGCRC0058 '
      if (error.response) {
        this.completeWord =
          this.errorMsg.MSGCRC0058.name +
          this.errorMsg.MSGCRC0058.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.completeWord =
          this.errorMsg.MSGCRC0005.name +
          this.errorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.showCompleteModal = true
    }
    this.showloadingModal = false
  },
  methods: {
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      return year + '/' + month + '/' + day
    },
    close(e) {
      this.showCompleteModal = false
      this.showExportModal = false
    },
    checkedPostsAction(e) {
      // クリックしたリストのチェックボックスをチェックする。
      this.$store.dispatch('assessmentInfos/checkedPostsAction', e)
    },
    checkedUsersAction(e) {
      // クリックしたリストのチェックボックスをチェックする。
      this.$store.dispatch('assessmentInfos/checkedUsersAction', e)
    },
    allCheckedPostsAction(e) {
      // ポストリストのチェックボックスを全てチェックする。
      this.postsChecked = !this.postsChecked
      for (let i = 0; i < this.posts.length; i++) {
        this.posts[i].checked = this.postsChecked
      }
    },
    allCheckedUsersAction(e) {
      // ユーザリストのチェックボックスを全てチェックする。
      this.usersChecked = !this.usersChecked
      for (let i = 0; i < this.users.length; i++) {
        this.users[i].checked = this.usersChecked
      }
    },
    closeModal(e) {
      this.showCompleteModal = false
      this.showExportModal = false
    },
    initAsUTC(date) {
      var local = new Date(date)
      var offset = local.getTimezoneOffset() / 60
      var utc = new Date(local.getTime() + offset * 60 * 60 * 1000)
      return utc
    },
    exportAction(e) {
      this.checkedUsersList = []
      this.checkedPostsList = []
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].checked === true) {
          let userId = this.users[i].userId
          let userName = this.users[i].familyName + this.users[i].name
          this.checkedUsersList.push({userId, userName})
        }
      }
      for (let i = 0; i < this.posts.length; i++) {
        if (this.posts[i].checked === true) {
          let postId = this.posts[i].postId
          let postName = this.posts[i].postName
          this.checkedPostsList.push({postId, postName})
        }
      }
      this.showExportModal = true
    },
    async exportList(e) {
      this.showloadingModal = true
      try {
        this.showExportModal = false
        let allAverageFlag
        if (document.getElementById('all_checkbox').checked) {
          allAverageFlag = true
          if (
            this.checkedUsersList.length + this.checkedPostsList.length + 1 >
            5
          ) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_270006
            let eventType = 9
            let reason = 'MSGCRC0060'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.completeWord =
              this.errorMsg.MSGCRC0060.name +
              this.errorMsg.MSGCRC0060.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showCompleteModal = true
            this.showloadingModal = false
            return
          }
        } else {
          allAverageFlag = false
          if (this.checkedUsersList.length + this.checkedPostsList.length > 5) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_270007
            let eventType = 9
            let reason = 'MSGCRC0060'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.completeWord =
              this.errorMsg.MSGCRC0060.name +
              this.errorMsg.MSGCRC0060.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showCompleteModal = true
            this.showloadingModal = false
            return
          }
        }
        let start = document.getElementById('start').value
        let end = document.getElementById('end').value
        let startDateTime = ''
        let endDateTime = ''
        if (start !== '') {
          var startDate = new Date(start)
          startDateTime = Date.parse(this.initAsUTC(startDate))
        } else {
          startDateTime = ''
        }
        if (end !== '') {
          var endDate = new Date(end)
          let endSecond = Date.parse(this.initAsUTC(endDate))
          endDateTime = endSecond + 24 * 60 * 60 * 1000 - 1
        } else {
          endDateTime = ''
        }
        let countUnits = document.getElementsByName('count_units')
        let countUnit
        for (let i = 0; i < countUnits.length; i++) {
          if (countUnits[i].checked) {
            countUnit = countUnits[i].value
            break
          }
        }
        let postList = []
        let users = this.checkedUsersList
        let posts = this.checkedPostsList
        let sumunit = countUnit
        if (startDateTime === '' && endDateTime === '') {
          postList.push({users, posts, sumunit, allAverageFlag})
        } else if (startDateTime === '') {
          postList.push({users, posts, endDateTime, sumunit, allAverageFlag})
        } else if (endDateTime === '') {
          postList.push({users, posts, startDateTime, sumunit, allAverageFlag})
        } else {
          postList.push({
            users,
            posts,
            startDateTime,
            endDateTime,
            sumunit,
            allAverageFlag
          })
          if (startDateTime > endDateTime) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_270008
            let eventType = 9
            let reason = 'MSGCRC0061'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.completeWord =
              this.errorMsg.MSGCRC0061.name +
              this.errorMsg.MSGCRC0061.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showCompleteModal = true
            this.showloadingModal = false
            return
          }
        }
        try {
          await this.$store.dispatch('assessmentInfos/setRatesInfos', postList)
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_270001
          let eventType = 3
          let reason = 'MSGCRC0056 '
          if (error.response) {
            this.completeWord =
              this.errorMsg.MSGCRC0056.name +
              this.errorMsg.MSGCRC0056.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            reason += error.response.status
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.completeWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showCompleteModal = true
          this.showloadingModal = false
          return
        }
        // APIからレスポンスが返ってきた後の処理
        let result = ''
        let rates = this.$store.state.assessmentInfos.rates
        if (rates[0].title.values.length === 0) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_270009
          let eventType = 9
          let reason = 'MSGCRC0062'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.completeWord =
            this.errorMsg.MSGCRC0062.name +
            this.errorMsg.MSGCRC0062.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
          this.showloadingModal = false
          return
        }
        if (rates[0].values.length === 0) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_270010
          let eventType = 9
          let reason = 'MSGCRC0063'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.completeWord =
            this.errorMsg.MSGCRC0063.name +
            this.errorMsg.MSGCRC0063.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
          this.showloadingModal = false
          return
        }
        result += rates[0].title.date + ','
        for (let i = 0; i < rates[0].title.values.length; i++) {
          result +=
          this.exportSetDoubleQuotation(rates[0].title.values[i])
          if (i === rates[0].title.values.length - 1) {
            result += '\n'
          } else {
            result += ','
          }
        }
        for (let i = 0; i < rates[0].values.length; i++) {
          result += rates[0].values[i].date + ','
          for (let j = 0; j < rates[0].values[i].values.length; j++) {
            result +=
            this.exportSetDoubleQuotation(rates[0].values[i].values[j])
            if (j === rates[0].values[i].values.length - 1) {
              result += '\n'
            } else {
              result += ','
            }
          }
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, '評価一覧.csv')
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '評価一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '評価一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_270004
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.completeWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_270005
        let eventType = 9
        let reason = 'MSGCRC0059'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.completeWord =
          this.errorMsg.MSGCRC0059.name +
          this.errorMsg.MSGCRC0059.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.start_datepicker,
.end_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
  width: 200px;
}
.content {
  width: calc(100% - 262px);
  color: #000;
}
.table,
.table_header,
.edit_table_content {
  width: 100%;
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/assessmentInfos/assessmentInfosList.vue